<template>
  <b-form-group label="Situação no ciclo" label-for="select-cycle-situation">
    <multiselect
      :value="computedValue"
      :options="myOptions"
      :multiple="false"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      :placeholder="placeholder"
      label="designation"
      track-by="value"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      @select="callback"
    >
      <span slot="noResult">Nada encontrado</span>
    </multiselect>
  </b-form-group>
</template>

<script>
export default {
  props: {
    placeholder: {
      default: "Todos",
      type: String,
    },
    selected: {default: null},
    value: {},
    callback: {},
    status: null,
  },
  data() {
    return {
      options: "",
      CycleSituation: [],
    };
  },

  mounted() {
    if (this.selected !== null && this.selected !== undefined) {
      this.value = this.selected;
    }
  },

  methods: {
    clearAll() {
      this.CycleSituation = [];
    },
  },
  computed: {
    myOptions() {
      return [
        {
          value: null,
          designation: "Todos",
        },
        {
          value: "regular",
          designation: "Regular",
        },
        {value: "retained", designation: "Retido"},
        {
          value: "cycle_retention",
          designation: "Permaneceu no ciclo",
        },
        {
          value: "conditional_progression",
          designation: "Com pendências",
        },
      ];
    },
    computedValue() {
      return this.myOptions.find((c) => c.value == this.value);
    },
  },
};
</script>
